import React from 'react'
import { PreviewBody, PreviewFooter, PreviewLabel, PreviewLayout } from '../sub-components/PreviewLayout'
import LoadingList from '../skeletons/LoadingList'
import LoadingDiscountStrip from '../skeletons/LoadingDiscountStrip'
import PreviewBanner from '../sub-components/PreviewBanner'
import { LoginPageType } from 'src/lib/types/uiPreview'
import LoadingPhoneInput from '../skeletons/LoadingPhoneInput'
import PreviewCTA from '../sub-components/PreviewCTA'

const LoginPage: React.FC<LoginPageType> = ({
  loginBanner,
  loginButtonCTAText,
  loginCouponVisibility,
  colorPalette
}) => {
  return (
    <PreviewLayout>
      <>
        <PreviewLabel>
          {loginBanner.enabled ? (
            <PreviewBanner
              backgroundColor={loginBanner.color ?? '#5a31f4'}
              textColor={loginBanner.textColor ?? '#FFFFFF'}
              bannerText={loginBanner.text ?? '(Enter some text to see a preview here)'}
            />
          ) : (
            <></>
          )}
        </PreviewLabel>

        <PreviewBody>
          <LoadingList
            length={1}
            skeleton={{
              layout: 'row',
              config: [
                { height: 1, width: 1 },
                { height: 1, width: 6 }
              ]
            }}
          />
          <LoadingDiscountStrip
            isHidden={!Boolean(loginCouponVisibility?.areCouponsVisible)}
            skeleton={{
              layout: 'row',
              justify: 'space-between',
              config: [
                {
                  layout: 'row',
                  config: [
                    { height: 1, width: 1 },
                    { height: 1, width: 6 }
                  ]
                },
                { height: 1, width: 1 }
              ]
            }}
            isCard={loginCouponVisibility?.visibilityExtent === 'cards'}
          />
          <LoadingPhoneInput
            borderColor={colorPalette.primaryColor}
            skeleton={{
              layout: 'row',
              config: [
                {
                  height: 1.5,
                  width: 14
                }
              ]
            }}
          />
        </PreviewBody>
        <PreviewFooter>
          <PreviewCTA
            color={colorPalette.primaryColor ?? '#5a31f4'}
            textColor={colorPalette.primaryTextColor ?? '#FFFFFF'}
            CTAText={loginButtonCTAText}
            isSecuredByTextEnabled={true}
            isAnchored={false}
          />
        </PreviewFooter>
      </>
    </PreviewLayout>
  )
}

export default LoginPage
